import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, Laptop, Monitor, Keyboard, Mouse, Mic, Headphones, Zap, Wrench, BadgeCheck, MessageCircle, ArrowRight, ExternalLink } from 'lucide-react';
import { CallbackButton } from './CallbackModal';

export const NAVEGAMER_STORE_URL = 'https://www.navegamer.com.br';
const WA = (msg) => `https://wa.me/5516991378312?text=${encodeURIComponent(msg)}`;

export const NAVE_LINES = [
  { icon: Laptop,   name: 'Notebooks Gamer NAVE',  desc: 'Linhas Estelar e SuperNova: Intel Core i7/i9 HX, RTX 4060 a 4090, tela 16" 240 Hz.', from: 'A partir de R$ 8.322 na loja NAVE', url: `${NAVEGAMER_STORE_URL}/collections/notebooks` },
  { icon: Monitor,  name: 'PCs Gamer / Desktops',  desc: 'Desktops NAVE para jogar, criar conteúdo, editar vídeo e trabalhar com IA.', from: 'Configuração sob medida', url: `${NAVEGAMER_STORE_URL}/collections/desktops` },
  { icon: Keyboard, name: 'Teclados',              desc: 'SteelSeries Apex 3, Apex 7 e mecânicos RGB com anti-ghosting.', from: 'Linha SteelSeries', url: `${NAVEGAMER_STORE_URL}/collections/teclados` },
  { icon: Mouse,    name: 'Mouses e Mousepads',    desc: 'SteelSeries Aerox, Rival e mousepads QcK para precisão máxima.', from: 'Linha SteelSeries', url: `${NAVEGAMER_STORE_URL}/collections/mouses` },
  { icon: Mic,      name: 'Microfones e Headsets', desc: 'Alias e Alias Pro para streamers, podcasts e reuniões.', from: 'Áudio profissional', url: `${NAVEGAMER_STORE_URL}/collections/microfones` },
  { icon: Headphones,name: 'Monitores Gamer',      desc: 'Monitores Full HD e QHD de alta taxa de atualização com FreeSync.', from: '75 Hz a 240 Hz', url: `${NAVEGAMER_STORE_URL}/collections/monitores` },
];

const WHY = [
  { icon: BadgeCheck, t: 'Afiliado oficial NAVE / Navegamer', d: 'A NAVE é a linha gamer e de alta performance do grupo Daten. Compre com um parceiro autorizado e preço de fábrica.' },
  { icon: Wrench,     t: 'Montagem, upgrade e suporte local',  d: 'Instalamos, otimizamos drivers, fazemos upgrade de memória, SSD e placa de vídeo em Ribeirão Preto.' },
  { icon: Zap,        t: 'Indicação certa para o seu uso',     d: 'Jogos competitivos, streaming, edição de vídeo, arquitetura ou IA: ajudamos a escolher a configuração ideal sem gastar demais.' },
];

const Navegamer = ({ showLearnMore = false }) => (
  <section id="navegamer" className="py-20 bg-slate-900 relative overflow-hidden" style={{ scrollMarginTop: '100px' }} data-testid="navegamer-section">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-fuchsia-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-cyan-500/5 rounded-full blur-3xl" />
    </div>
    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-3xl mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-fuchsia-500/10 border border-fuchsia-500/30 rounded-full text-fuchsia-300 text-sm font-semibold mb-4">
          <Gamepad2 className="w-4 h-4" /> Linha Gamer · Afiliado Oficial NAVE
        </div>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">
          Navegamer: PCs gamer, notebooks e periféricos <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-400 to-cyan-400">com suporte da Fernando Tech</span>
        </h2>
        <p className="text-slate-400 leading-relaxed">
          A <strong className="text-white">NAVE (Navegamer)</strong> desenvolve notebooks e computadores de alto desempenho para gamers, criadores de conteúdo e profissionais.
          Como afiliado oficial, a Fernando Tech indica a configuração certa, acompanha a compra e oferece montagem, upgrade e suporte técnico em Ribeirão Preto e região.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
        {NAVE_LINES.map(({ icon: Icon, name, desc, from, url }) => (
          <article key={name} className="group rounded-2xl bg-slate-950/70 border border-slate-800 hover:border-fuchsia-500/50 p-5 transition-all hover:-translate-y-1" data-testid={`nave-line-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
            <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-fuchsia-500/10 border border-fuchsia-500/20 mb-3">
              <Icon className="w-5 h-5 text-fuchsia-300" />
            </span>
            <h3 className="text-white font-bold mb-1">{name}</h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-2">{desc}</p>
            <p className="text-cyan-300 text-xs font-semibold mb-4">{from}</p>
            <div className="flex flex-wrap gap-2">
              <a href={WA(`Olá! Tenho interesse em ${name} (Navegamer). Pode me ajudar a escolher e passar preço?`)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold transition-colors">
                <MessageCircle className="w-3.5 h-3.5" /> Cotar no WhatsApp
              </a>
              <a href={url} target="_blank" rel="noopener noreferrer sponsored" className="inline-flex items-center gap-1 px-3.5 py-2 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-semibold transition-colors">
                Ver na loja <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </article>
        ))}
      </div>

      <div className="grid md:grid-cols-3 gap-4 mb-12">
        {WHY.map(({ icon: Icon, t, d }) => (
          <div key={t} className="flex gap-4 rounded-2xl bg-slate-950/50 border border-slate-800 p-5">
            <Icon className="w-6 h-6 text-fuchsia-400 shrink-0 mt-0.5" />
            <div>
              <h3 className="text-white font-semibold mb-1">{t}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row flex-wrap items-center gap-3">
        <a href={WA('Olá! Quero montar/comprar um PC gamer ou notebook NAVE com a ajuda da Fernando Tech.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-lg shadow-emerald-500/20 transition-all hover:scale-105" data-testid="navegamer-whatsapp">
          <MessageCircle className="w-4 h-4" /> Montar meu setup pelo WhatsApp
        </a>
        <CallbackButton interesse="Navegamer (PC gamer / periféricos)" testId="navegamer-callback" />
        {showLearnMore && (
          <Link to="/navegamer" className="inline-flex items-center gap-1.5 text-cyan-400 hover:text-cyan-300 text-sm font-semibold" data-testid="navegamer-learn-more">
            Saiba mais sobre a Navegamer <ArrowRight className="w-4 h-4" />
          </Link>
        )}
      </div>
    </div>
  </section>
);

export default Navegamer;
